export const prosBrowseZonesExperiment = {
  '670-21': 'BROWSE_ZONE_B',
  '670-22': 'BROWSE_ZONE_C',
  '820-21': 'BROWSE_ZONE_B',
  '823-21': 'BROWSE_ZONE_D',
  '824-21': 'BROWSE_ZONE_E',
  '829-21': 'BROWSE_ZONE_F',
  '830-21': 'BROWSE_ZONE_G',
  '1213-21': 'BROWSE_ZONE_H',
  '1214-21': 'BROWSE_ZONE_I',
  '1215-21': 'BROWSE_ZONE_J',
  '1216-21': 'BROWSE_ZONE_K',
  '1217-21': 'BROWSE_ZONE_L',
};

export default prosBrowseZonesExperiment;
